import React from 'react';

interface CheckmarkIcon20Props {
  width?: number | string;
  height?: number | string;
  className?: string;
  fill?: string;
}

const CheckmarkIcon20: React.FC<CheckmarkIcon20Props> = ({
  width = 20,
  height = 20,
  className,
  fill = '#505050'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.86433 15.7345C7.64167 15.7345 7.43074 15.6359 7.28816 15.465L3.54109 10.9669C3.27547 10.6486 3.31941 10.1749 3.63679 9.91028C3.95417 9.64466 4.42683 9.68665 4.69343 10.006L7.84675 13.7921L15.2862 4.32335C15.5421 3.99718 16.0147 3.94152 16.3389 4.19641C16.6651 4.45227 16.7217 4.92395 16.4659 5.24914L8.45416 15.4474C8.31451 15.6261 8.10162 15.7316 7.87506 15.7345L7.86433 15.7345Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckmarkIcon20;
